export enum BubbleModeEnum {
  WRAPPED = 'wrapped',
  BACKGROUND = 'background',
  CLIPPED = 'clipped',
  OVERSIZE = 'oversize',
}

export const getBubbleModeValues = () => Object.values(BubbleModeEnum) as [string, ...string[]];
